﻿export function TableOfContent() {
	let allHeadLines = Array.from(document.querySelectorAll('h2'));
	if (allHeadLines.length == 0) {
		allHeadLines = Array.from(document.querySelectorAll('h3'));
	}

	const inlineWrapper = document.createElement('div');
	inlineWrapper.className = 'dn-l';

	const ul = document.createElement('ul');
	ul.className = 'list ma0 pa0';

	let innerHTML = '';
	for (const headline of allHeadLines) {
		headline.id = headline.innerHTML.replace(/\s/g, '');
		innerHTML += `<li>
				<a class="db hover-bg-near-white bg-animate ph1 pv1-l" href=#${headline.id}>
					${headline.innerHTML}
				</a>
			</li>`;
	}
	ul.innerHTML = innerHTML;
	inlineWrapper.innerHTML = ul.outerHTML;

	const header = document.querySelector('h1');
	header.insertAdjacentElement('afterend', inlineWrapper);

	const sidebar = document.getElementById('table-of-content');
	sidebar.innerHTML = ul.outerHTML;
}
